// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__fB9x7","actionsContainer":"styles_actionsContainer__zfbO8"};